var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFireflyLogo = function SvgFireflyLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "firefly-logo_svg__Layer_2",
    width: "100%",
    "data-name": "Layer 2",
    viewBox: "0 0 56 54"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".firefly-logo_svg__cls-2{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "firefly-logo_svg__Surfaces"
  }, /*#__PURE__*/React.createElement("g", {
    id: "firefly-logo_svg__DC_EC_Logo_Surface",
    "data-name": "DC/EC Logo Surface"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "firefly-logo_svg__Outline_no_shadow",
    width: 56,
    height: 54,
    "data-name": "Outline no shadow",
    rx: 9.91,
    ry: 9.91,
    style: {
      fill: "#eb1000"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "firefly-logo_svg__Outlined_Mnemonics_Logos",
    "data-name": "Outlined Mnemonics &amp; Logos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "firefly-logo_svg__Firefly_Mnemonic_One_Sparkle",
    "data-name": "Firefly Mnemonic One Sparkle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.57 37.57c0 .22-.1.32-.32.32h-4.57c-.18 0-.25-.13-.25-.32V13.94c0-.21.07-.29.28-.29h14.65c.25 0 .31.07.35.31l.41 3.99c.04.22-.07.32-.31.32H21.57v5.62h9.23c.21 0 .31.07.31.29v4.04c0 .22-.11.29-.29.29h-9.25v9.06ZM34.86 19.81c0-.21.1-.31.31-.31h4.55c.24 0 .31.06.31.3v17.74c0 .24-.07.34-.34.34h-4.46c-.25 0-.37-.11-.37-.35V19.8ZM38.56 15.5l2.26.51c.89.2 1.51-.86.89-1.53l-1.57-1.7a.899.899 0 0 1-.22-.83l.51-2.26c.2-.89-.87-1.5-1.54-.88l-1.7 1.57c-.22.21-.54.29-.83.22l-2.26-.51c-.89-.2-1.51.86-.89 1.53l1.57 1.7c.21.22.29.53.22.83l-.51 2.26c-.2.89.87 1.5 1.54.88l1.7-1.57c.22-.21.54-.29.83-.22Z",
    className: "firefly-logo_svg__cls-2"
  })))));
};
export default SvgFireflyLogo;